<template>
  <div class="login">
    <div class="inner">
      <h1>
        Welcome to 
      </h1>
      <h3>
        Sign in to Brown-Forman Capability Assessment
      </h3>
      <button @click="login" class="login-btn">
        Continue
      </button>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Login',
}
</script>

<style scoped>
.login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
}

.inner {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.login-btn {
  outline: 0;
    border: 0;
    background: rgba(0, 0, 0, .87);
    padding: 5px 25px;
    border-radius: 10px;
    color: white;
}

h3 {
  margin-top: 10px;
  margin-bottom: 45px;
}
</style>

